import _ from 'lodash';
import { Reducer } from 'redux';
import * as actionTypes from 'constants/action-types';
import { MarFilesState } from 'types/rest/marFilesTypes';
import { MarFilesActionTypes } from 'store/marFiles/marFilesActionTypes';

const initialState: MarFilesState = {
  dataList: [],
  isLoading: false,
  duplicate: {
    found: false,
    asset: {
      id: 0,
      created: 0,
      name: '',
      description: '',
      serviceId: 0,
      serviceName: '',
      createdBy: '',
      createdDate: '',
      updated: 0,
      updatedBy: '',
      tags: [],
      original: {
        name: '',
        description: '',
        serviceId: 0,
        tags: [],
      },
    },
  },
  expandedMarFileId: 0,
  activePage: 0,
  currentSearchTerm: '',
  activeVirtualService: 0,
  selectedMarFilesCount: 0,
  selectedMarFiles: [],
  totalMarFiles: 0,
  selectedMarAssetId: 0,
  selectedMarFileName: '',
  selectedTagVal: '',
};

export const marFilesReducer: Reducer<MarFilesState, MarFilesActionTypes> = (
  state = initialState,
  action,
): MarFilesState => {
  switch (action.type) {
    case actionTypes.VIEW_MAR_FILES:
      const sortedMarFilesList = _.orderBy(action.payload, 'id', 'desc');
      return {
        ...state,
        dataList: _.map(sortedMarFilesList, item => {
          item = {
            ...item,
            original: {
              name: item.name,
              description: item.description,
              serviceId: item.serviceId,
              tags: item.tags,
            },
          };

          return item;
        }),
        isLoading: false,
        duplicate: {
          ...state.duplicate,
          found: false,
        },
        totalMarFiles: sortedMarFilesList.length,
      };
    case actionTypes.ASSET_FILTER_CHANGED:
      return {
        ...state,
        currentSearchTerm: action.payload.searchTerm,
        activeVirtualService: action.payload.serviceId,
      };
    case actionTypes.DELETE_MAR_FILE:
      const dataListAfterDelete = _.filter(state.dataList, item => item.id !== action.payload.id);
      return {
        ...state,
        dataList: dataListAfterDelete,
        isLoading: false,
        duplicate: {
          ...state.duplicate,
          found: false,
        },
        totalMarFiles: dataListAfterDelete.length,
      };
    case actionTypes.LOADING_MAR_FILES_LIST:
      return {
        ...state,
        isLoading: action.payload.displayLoading,
      };
    case actionTypes.DUPLICATE_ASSET_DETECTED:
      return {
        ...state,
        isLoading: false,
        duplicate: {
          found: action.payload.found,
          asset: action.payload.asset,
        },
      };
    case actionTypes.MAR_FILES_TOGGLE_EXPAND_ROW:
      const stateCopy = { ...state };
      stateCopy.expandedMarFileId = action.payload;
      return stateCopy;

    default:
      return state;
  }
};
